import type { KeyValueItem } from '../types/apiTypes';

export enum DefaultKeys {
  PHONE = 'Phone',
  ADDRESS = 'Address',
  COMPANY_NAME = 'Company Name',
  EIN = 'EIN',
  COMPANY_EMAIL = 'Company Email',
  AUTHORIZED_REP = 'Authorized Representative Name'
}

export const keyValueListToObj = (
  keyValueList: KeyValueItem[]
): Record<string, string> => {
  const result: Record<string, string> = {};
  keyValueList.forEach((keyValueItem) => {
    result[keyValueItem.key] = keyValueItem.value;
  });
  return result;
};
